import {
  AppSubscriptionStatus,
  SubscriptionOfferStatus,
  SubscriptionOffersQuery,
  AppSubscriptionsFragment,
  StandingOffersQuery,
  StandingOfferStatus
} from "@/gql/__generated__/graphql";
import { ArrayElement } from "@/lib/ts-helpers/ArrayElement";

export type SubscriptionOffer = ArrayElement<
  Extract<
    SubscriptionOffersQuery["organization"],
    { __typename: "Organization" }
  >["outboundSubscriptionOffers"]
>;

export type SubscriptionOfferTable = {
  id: string;
  appName: string;
  appImage: string | undefined | null;
  email: string;
  status: SubscriptionOfferStatus;
  reference?: string;
  createdAt: Date;
  monthlyPriceUSD: string | undefined | null;
  trialDays: number | undefined | null;
  expiresAt?: Date | null;
};

export type StandingOffer = ArrayElement<
  Extract<
    StandingOffersQuery["organization"],
    { __typename: "Organization" }
  >["standingOffers"]
>;

export type StandingOfferTable = {
  id: string;
  appName: string;
  appImage: string | undefined | null;
  status: StandingOfferStatus;
  reference?: string;
  createdAt: Date;
  monthlyPriceUSD: string | undefined | null;
  trialDays: number | undefined | null;
};

type BaseSubscriptionTable = {
  id: string;
  appName: string;
  appImage: string | undefined | null;
  organizationName: string;
  status: AppSubscriptionStatus;
  createdAt: Date;
  renewsAt: Date | undefined | null;
  expiresAt: Date | undefined | null;
  monthlyPriceUSD: string | undefined | null;
  reference?: string;
  type: "inbound" | "outbound";
};

type InboundSubscriptionTable = BaseSubscriptionTable & {
  type: "inbound";
  reference: undefined;
};

type OutboundSubscriptionTable = BaseSubscriptionTable & {
  type: "outbound";
  reference: string;
};

export type SubscriptionTable =
  | InboundSubscriptionTable
  | OutboundSubscriptionTable;

export function isInboundSubscription(
  sub: SubscriptionTable
): sub is InboundSubscriptionTable {
  return sub.type === "inbound";
}

export function isOutboundSubscription(
  sub: SubscriptionTable
): sub is OutboundSubscriptionTable {
  return sub.type === "outbound" && typeof sub.reference === "string";
}

export type SubscriptionOrganizationType = keyof Pick<
  AppSubscriptionsFragment,
  "inboundOrganization" | "outboundOrganization"
>;
